<div *ngIf="!isSubscriber && isWoohoo" style="margin-bottom: 20px; margin-top: 20px; background: yellow; box-shadow: 3px 3px 15px #333; border-radius: 15px;  background: linear-gradient(0deg,rgb(53, 1, 68),#c1058c 42%) no-repeat!important;;
background-image: url('https://www.transparenttextures.com/patterns/concrete-wall.png'); color: #333; padding: 40px; text-align: center; font-weight: 900;">
  <div class="container">
      <div class="row">
        <div class="col">
         <img class="ctaIMG" src='assets/img/monthEndMania.png' />
        </div>
        <div class="col">
          <h3 class="ctaDate">24 April to 4 May</h3>
          <h3 class="ctaSubHead">Extra Daily Prizes:</h3>
          <h3 class="ctaBlurb">10 winners will each win R50 in airtime (R500 in airtime given away each day)<br/> + you can still win a share of R1000 daily!</h3>
          <a style="font-size: 35px; width: 100%; margin-left: 0px; margin-top: 45px; line-height: 40px; background-color: yellow!important; color: #000!important; font-weight: bold;" class="unsubbutton white-outline-button subButton" href="https://landing.woohoo365.co.za/woohoo365/join003/index.html?utm_source=Woohoo_CTA_HomePage&utm_medium=banner&utm_campaign=WooHoo_SignUp">Subscribe Now</a>
          
        </div>
      </div>
      </div>

</div>